import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { Form, FormGroup, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import DataTable from "react-data-table-component";
import ReactPaginate from "react-paginate";
import TripModalV2 from "./Components/CreateTripV2";
import Tooltip from "@mui/material/Tooltip";
import SvgImage from "../Icons/Icons";
import { DatePickerField, DateRangePickerField } from "../core/inputs/input";
import {
  downloadTripDataExcel,
  findTripAddress,
  getLRList,
  getTripsNew,
} from "../../services/Store/Actions/TripsAction";
import Toast from "../subComponents/toast";
import { getVehicleListAction } from "../../services/Store/Actions/manageVehicleAction";
import { getDriverList } from "../../services/Store/Actions/driverslistActions";
import moment from "moment";
import {
  removeItemFromAsyncStorage,
  storeDataToAsyncStorage,
} from "../../services/Utils/functions";
import { BallTriangle } from "react-loader-spinner";
import EndTripModal from "../TripsDetailsV2/Components/EndTrip";
import ChooseRoute from "../LoadReceipt/Components/ChooseRoute";
import AddLr from "./Components/AddLr";
import CreateTripFromLR from "../ManageCustomersDetailsV2/SubComponents/CreateTripFromLR";
import PaymentDetails from "../ManageCustomersDetailsV2/SubComponents/PaymentDetails";
import AddBulkTrip from "./Components/AddBulkTrips";
import Switch from "react-switch";
import Collapsible from "react-collapsible";
import FreightUpdateRender from "../EndTrip/Components/FreightUpdateRender";
import { getBranch } from "../../services/Store/Actions/UserManagementAction";
function TripsMainV2(props) {
  const { sideBar } = props;
  let [searchParams, setSearchParams] = useSearchParams();

  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [item, setItem] = useState({});
  const [color1, setColor1] = useState(-1);
  const [color2, setColor2] = useState(-1);
  const [tripExpense, setTripExpense] = useState();
  const [openEndTripModal, setOpenEndTripModal] = useState(false);
  const toggleEndTripModal = () => {
    setOpenEndTripModal(
      ["2", "3", 2, 3].includes(isTrips) ? !openEndTripModal : 0
    );
  };
  const [currentRow, setCurrentRow] = useState(null);
  const [fleetIdTemp, setFleetIdTemp] = useState(searchParams.get("fleetId") || "");
  const [driverIdTemp, setDriverIdTemp] = useState(searchParams.get("driverId") || "");
  const [all, setAll] = useState(!searchParams.get("isActive") ? true : searchParams.get("isActive") === "all" ? true : false);
  const [completed, setCompleted] = useState(searchParams.get("isActive") === "completed" ? true : false);
  const [pending, setPending] = useState(searchParams.get("isActive") === "pending" ? true : false);
  const [running, setRunning] = useState(searchParams.get("isActive") === "running" ? true : false);
  const [delayed, setDelayed] = useState(searchParams.get("isActive") === "delayed" ? true : false);

  const [openLrList, setOpenLrList] = useState(false);
  const [modal, setModal] = useState(false);
  const [startDateFrom, setStartDateFrom] = useState(searchParams.get("startDateFrom"));
  const [startDateTo, setStartDateTo] = useState(searchParams.get("startDateTo"));
  console.log("searchParamssearchParams",params, startDateTo);

  const [endDateFrom, setEndDateFrom] = useState(searchParams.get("endDateFrom"));
  const [endDateTo, setEndDateTo] = useState(searchParams.get("endDateTo"));
  const [searchSource, setSearchSource] = useState("");
  const [searchDestination, setSearchDestination] = useState("");
  const [sourceAddress, setSourceAddress] = useState(searchParams.get("sourceAddress") || "");
  const [destinationAddress, setDestinationAddress] = useState(searchParams.get("destinationAddress") || "");
  const [vrn, setVrn] = useState(searchParams.get("vrn") || "")
  const [driverName, setDriverName] = useState(searchParams.get("driverName") || "")
  const [addressSource, setAddressSource] = useState(searchParams.get("addressSource") || "")
  const [addressDest, setAddressDest] = useState(searchParams.get("addressDest") || "")
  const [branchName, setBranchName] = useState(searchParams.get("branchName") || "")
  const [chooseRouteModal, setChooseRouteModal] = useState(false);
  const [selectedLr, setSelectedLr] = useState([]);
  const [createTripModal, setCreateTripModal] = useState(false);
  const [bulkSalary, setBulkSalary] = useState(false);
  const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);
  const [routeData, setRouteData] = useState({});
  const [tripData, setTripData] = useState({});
  const [vehicleMilage, setVehicleMilage] = useState(null);
  const [driverSalary, setDriverSalary] = useState(null);
  const [tripAnalysis, setTripAnalysis] = useState(false);
  const [isTrips, setIsTrips] = useState(0);
  const [display1, setDisplay1] = useState(false);
  const [display2, setDisplay2] = useState(false);
  const [display3, setDisplay3] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDriver, setOpenDriver] = useState(false);
  const [search, setSearch] = useState("");
  const [searchDriver, setSearchDriver] = useState("");
  const [tripNoTemp, setTripNoTemp] = useState(searchParams.get("tripNo") || "");
  const [refresh, setRefresh] = useState(false);
  const [searchBranch, setSearchBranch] = useState("");
  const [open2, setOpen2] = useState(false);
  const [branchId, setBranchId] = useState("");
  const [newOffset,setNewOffset] =useState(parseInt(searchParams.get("offset")) || 0);
  const [selectedPage, setSelectedPage] = useState(parseInt(searchParams.get("offset")) / 10 || 0)
  const { authUser } = useSelector((state) => state?.loginReducer);
  const { managerControlList } = useSelector((state) => state?.userManagement);
  const toastObject = useSelector((state) => state?.app?.toastObject);
  const tripAddress = useSelector((state) => state?.trip?.tripAddressDetails);
  let {
    fetchingTrips,
    tripsCount,
    tripsListNew,
    countAll,
    countNotStarted,
    countComplete,
    countRunning,
    countDelayed,
  } = useSelector((store) => store?.trip);

  const allFleets = useSelector(
    (state) => state?.manageVehicle?.allFleets?.rows
  );
  const vehCount = useSelector(
    (state) => state?.manageVehicle?.allFleets?.count
  );
  const driverList = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.rows
  );
  const driverCount = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.count
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const datepickerRefEnd = useRef();
  const datepickerRefStart = useRef();
  let totalExpenseCount = pending ?  countNotStarted : completed ?  countComplete : running ?  countRunning : delayed ?  countDelayed : countAll === undefined ? 0 : countAll;
  let pageCount =
    totalExpenseCount % 10 === 0
      ? totalExpenseCount / 10
      : Math.floor(totalExpenseCount / 10) + 1;
   
  const fastVeh =
    vehCount > 0 ? allFleets?.find((ele) => ele?.Fastag !== null) : "value";

  const createTripV2 = () => setModal(isTrips == 3 ? !modal : 0);
  const showRouteModalToggle = () => setChooseRouteModal(true);
  const chooseRouteModalToggle = () => setChooseRouteModal(!chooseRouteModal);
  const toggleOpenLrList = () =>
    setOpenLrList(["3", 3].includes(isTrips) ? !openLrList : 0);
  const closeOpenLrList = () =>
    setOpenLrList(["3", 3].includes(isTrips) ? false : 0);

  const createTripModalToggle = () => setCreateTripModal(!createTripModal);

  const paymentDetailsModalToggle = () =>
    setPaymentDetailsModal(!paymentDetailsModal);

  const toggleTripAnalysis = () => {
    setTripAnalysis(!tripAnalysis);
    navigate("/tripAnalysis");
  };
  const findSearch1 = () => {
    setColor1(-1);
    dispatch(
      findTripAddress({
        offset: 0,
        search: searchSource,
        // minKyc: "",
        // sortAs: "",
        // sortBy: "",
      })
    );
  };
  const findSearch2 = () => {
    setColor2(-1);
    dispatch(
      findTripAddress({
        offset: 0,
        search: searchDestination,
        // minKyc: "",
        // sortAs: "",
        // sortBy: "",
      })
    );
  };
  useEffect(()=> {
    setSelectedPage(newOffset/10)
  }, [newOffset])
  const branchList = useSelector(
    (state) => state?.userManagement?.branchData.rows
  );
  const branchCount = useSelector(
    (state) => state?.userManagement?.branchData.count
  );
  useEffect(() => {
    console.log("jijijr", searchBranch);
    let timeout;
    if (searchBranch == "") {
      dispatch(
        getBranch({
          offset: "",
          search: searchBranch,
          minKyc: "",
          sortAs: "",
          sortBy: "",
          limit: 10,
        }, ()=>{})
      );
    } else {
      timeout = setTimeout(() => {
        dispatch(
          getBranch({
            offset: "",
            search: searchBranch,
            minKyc: "",
            sortAs: "",
            sortBy: "",
            limit: 10,
          }, (res) => {console.log(res?.data)})
        );
      }, 250);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [searchBranch]);
  const financialYearList = [
    {
      id: 1,
      title: "2022 - 23",
      from: new Date("04-01-2022"),
      to: new Date("03-31-2023"),
    },
    {
      id: 2,
      title: "2023 - 24",
      from: new Date("04-01-2023"),
      to: new Date("03-31-2024"),
    },
    {
      id: 3,
      title: "2024 - 25",
      from: new Date("04-01-2024"),
      to: new Date("03-31-2025"),
    },
  ];
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const handleClickDatepickerIcon1 = () => {
    const datepickerElement = datepickerRefStart.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };

  const LrList = ({ data }) => {
    console.log("jnuefnueurh", data);
    const [view, setView] = useState(false);
    const [openFreight, setOpenFreight] = useState(false);
    const [freightNo, setFreightNo] = useState(null);
    const navigate = useNavigate();

    return (
      <div>
        {!data?.Freights || data?.Freights?.length < 1 ? (
          <div style={{ textAlign: "center", padding: "31px 0 31px 0 " }}>
            No Load Reciept attached in this trip
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                height: "40px",
                paddingLeft: "20px",
                paddingRight: "20px",
                textAlignLast: "center",
                background: "#ededf1",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              <td style={{ width: "20%" }}>Lr No.</td>
              {/* <td style={{ width: "20%" }}>Source</td>
              <td style={{ width: "20%" }}>Destination</td> */}
              <td style={{ width: "25%" }}>Start Date</td>
              <td style={{ width: "25%" }}>End Date</td>
              <td style={{ width: "20%" }}>Amount</td>
              <td style={{ width: "20%" }}>Status</td>
              <td style={{ width: "20%" }}>Pay By</td>
              <td style={{ width: "20%" }}>{}</td>
            </div>
            {data?.Freights?.map((elem, i) => {
              console.log("elelemeelemm", elem);
              const payBy =
                elem.customerId == elem.consignorId
                  ? elem.consignorName
                  : elem.customerId == elem.consigneeId
                  ? elem.consigneeName
                  : elem.transportorName;
              return (
                <div>
                  <Collapsible
                    trigger={
                      <div
                        className=""
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          height: "50px",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          textAlignLast: "center",
                          fontSize: "16px",
                        }}
                        onClick={() => {
                          setFreightNo(i);
                          setView(false);
                        }}
                      >
                        <td
                          style={{
                            width: "20%",
                            cursor: "pointer",
                            textDecorationLine: "underline",
                            color: "blue",
                          }}
                          onClick={(e) => {
                            console.log("ddddkooooo", elem, startDateFrom,endDateFrom );
                            navigate(`/lr/${elem?.freightId}`, {
                              state: {
                                lr: elem,
                                fleetId: elem?.fleetId,
                                driverId: elem?.userId,
                                tripNo: elem?.tripId,
                                lrNo: elem?.lrNo,
                                startTime: startDateFrom,
                                endTime: endDateFrom,
                                source: elem?.fromAddress,
                                destination: elem?.toAddress,
                                freightId: elem?.freightId,
                              },
                            });
                          }}
                        >
                          {elem?.lrNo}
                        </td>
                        <td style={{ width: "25%" }}>{elem?.startDate}</td>
                        <td style={{ width: "25%" }}>{elem?.endDate}</td>
                        <td style={{ width: "20%" }}>₹ {elem?.freightAmount}</td>
                        <td style={{ width: "20%" }}>                           
                           <div className="">
                              {elem?.status == 12 ? (
                                "Delivered"
                              ) : elem?.status == 11 ? (
                                "Unloading"
                              ) : elem?.status == 1 ? (
                                "Running"
                              ) : elem?.status == 2 ? (
                                "Completed"
                              ) : elem?.status == 0 ? (
                                "Not Stated"
                              ) : ""}
                            </div></td>
                        <td style={{ width: "20%" }}>
                          {" "}
                          <div
                            onClick={(e) => {
                              console.log("lkjkkkiiii", i);
                              navigate(`/Customers/${elem?.customerId}`);
                            }}
                            style={{
                              cursor: "pointer",
                              textDecorationLine: "underline",
                              color: "blue",
                            }}
                          >
                            {payBy}
                          </div>
                        </td>
                        <td style={{ width: "20%" }}>
                          {/* <button 
             style={{width: "60px", height:"25px",borderRadius: "5px",backgroundColor: "#FFF",borderColor: "#2E7C7B",}}
             onClick={() => {
               console.log("onClickonClickonClick")
               setIsOpen(!isOpen)}}
           >
           <text>View</text>
           </button> */}
                          <div className="d-flex">
                              <button
                                style={{
                                  // width: "60px",
                                  // height: "25px",
                                  borderRadius: "5px",
                                  backgroundColor: "#FFF",
                                  borderColor: "#e9e9e9",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  setFreightNo(i);
                                  setView(false);
                                }}
                              >
                                <SvgImage
                                  name="AddAttachment"
                                  height="20"
                                  width="20"
                                />
                                <div style={{ marginLeft: "6px" }}>POD</div>
                              </button>
                              <div className="">
                              {elem?.podUrlData?.length > 0 ? (
                                <SvgImage name="circleTick" />
                              ) : (
                                ""
                              )}
                            </div>

                          </div>
                        </td>
                      </div>
                    }
                    // triggerSibling="hskdg shkdg"
                    // onOpening={}
                  >
                    <div style={{ margin: "10px" }}>
                      {/* <FreightRender elem={elem} i={i} /> */}

                      <div style={{ marginTop: "2px" }}>
                        {freightNo == i ? (
                          <FreightUpdateRender
                            freight={elem}
                            view={view}
                            tripId={data?.tripId}
                            refreshList={() => {
                              setRefresh(!refresh);
                            }}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </Collapsible>
                </div>
              );
            })}
            <hr style={{ border: "2px solid #ededf1" }}></hr>
          </>
        )}
      </div>
    );
  };

  const handlePageClick = (event) => {
     setNewOffset(event.selected * 10)
     setSearchParams({...params,offset: event.selected * 10,isActive: pending ? "pending" : completed ? "completed" : running ? "running" : delayed ? "delayed" : "all" })
    //  setSelectedPage(event.selected)
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    console.log("event heree", event.selected);
    let payload = {};
    if (pending) {
      payload["isActive"] = "1";
    }
    if (completed) {
      payload["isActive"] = "3";
    }
    if (running) {
      payload["isActive"] = "2";
    }
    if (delayed) {
      payload["isActive"] = "9";
    }
    let timeout;
    if(tripNoTemp == ""){
      dispatch(
        getTripsNew({
          ...payload,
          offset: event.selected * 10,
          limit: 10,
          // isActive: "",
          fleetId: fleetIdTemp,
          driverId: driverIdTemp,
          tripNo: tripNoTemp,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
          endDateFrom: endDateFrom,
          endDateTo: endDateTo,
          source: sourceAddress,
          destination: destinationAddress,
          branchId: branchId,
        })
      );
    }else{
      timeout = setTimeout(() => {
        dispatch(
          getTripsNew({
            ...payload,
            offset: event.selected * 10,
            limit: 10,
            // isActive: "",
            fleetId: fleetIdTemp,
            driverId: driverIdTemp,
            tripNo: tripNoTemp,
            startDateFrom: startDateFrom,
            startDateTo: startDateTo,
            endDateFrom: endDateFrom,
            endDateTo: endDateTo,
            source: sourceAddress,
            destination: destinationAddress,
            branchId: branchId,
          })
        );
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
    };
    // setOffset(newOffset);
  };
  const filterList = (k) => {
    // setSelectedPage(0)
    setNewOffset(0)
    setSearchParams({...params,offset: 0,isActive: k})
    if (k === "all") {
      setAll(true);
      setCompleted(false);
      setRunning(false);
      setDelayed(false);
      setPending(false);
      dispatch(
        getTripsNew({
          offset: 0,
          limit: 10,
          fleetId: fleetIdTemp,
          driverId: driverIdTemp,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
          endDateFrom: endDateFrom,
          endDateTo: endDateTo,
          source: sourceAddress,
          destination: destinationAddress,
          tripNo: tripNoTemp,
          branchId: branchId,
        })
      );
    } else if (k === "pending") {
      setAll(false);
      setCompleted(false);
      setRunning(false);
      setDelayed(false);
      setPending(true);
      // Tripcompleted()
      dispatch(
        getTripsNew({
          isActive: "1",
          offset: 0,
          limit: 10,
          fleetId: fleetIdTemp,
          driverId: driverIdTemp,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
          endDateFrom: endDateFrom,
          endDateTo: endDateTo,
          source: sourceAddress,
          destination: destinationAddress,
          tripNo: tripNoTemp,
          branchId: branchId,

        })
      );
    } else if (k === "completed") {
      setAll(false);
      setCompleted(true);
      setRunning(false);
      setDelayed(false);
      setPending(false);
      // Tripcompleted()
      dispatch(
        getTripsNew({
          isActive: "3",
          offset: 0,
          limit: 10,
          fleetId: fleetIdTemp,
          driverId: driverIdTemp,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
          endDateFrom: endDateFrom,
          endDateTo: endDateTo,
          source: sourceAddress,
          destination: destinationAddress,
          tripNo: tripNoTemp,
          branchId: branchId,

        })
      );
    } else if (k === "running") {
      setAll(false);
      setCompleted(false);
      setRunning(true);
      setDelayed(false);
      setPending(false);
      dispatch(
        getTripsNew({
          isActive: "2",
          offset: 0,
          limit: 10,
          fleetId: fleetIdTemp,
          driverId: driverIdTemp,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
          endDateFrom: endDateFrom,
          endDateTo: endDateTo,
          source: sourceAddress,
          destination: destinationAddress,
          tripNo: tripNoTemp,
          branchId: branchId,

        })
      );
    } else if (k === "delayed") {
      setAll(false);
      setCompleted(false);
      setRunning(false);
      setDelayed(true);
      setPending(false);
      dispatch(
        getTripsNew({
          isActive: "9",
          offset: 0,
          limit: 10,
          fleetId: fleetIdTemp,
          driverId: driverIdTemp,
          startDateFrom: startDateFrom,
          startDateTo: startDateTo,
          endDateFrom: endDateFrom,
          endDateTo: endDateTo,
          source: sourceAddress,
          destination: destinationAddress,
          tripNo: tripNoTemp,
          branchId: branchId,

        })
      );
    }
  };
  const onSelect = (row) => {
    storeDataToAsyncStorage("row", row);
    setItem(row);
    navigate(`/trips/${row.tripId}`);
    console.log("dsadasddsadasddsadasddsadasd", row);

    // setItem(row);
    console.log("thissssssssssssss", row);
  };

  let columns;
  {
    tripsListNew.map((i, k) => {
      columns = [
        {
          name: "Trip No",
          selector: (i) => i.tripNo,
        },
        {
          name: "Vehicle No",
          selector: (i) => i?.Fleet?.regNumber,
        },
        {
          name: "From",
          selector: (i) => (
            <Tooltip title={i?.sourceAddress?.pincode}>
              {i.source.length == 36
                ? i.sourceAddress?.cityName + ", " + i.sourceAddress?.stateName
                : i.source}
            </Tooltip>
          ),
        },
        {
          name: "To",
          selector: (i) => (
            <Tooltip title={i?.destAddress?.pincode}>
              {i.destination.length == 36
                ? i.destAddress?.cityName + ", " + i.destAddress?.stateName
                : i.destination}
            </Tooltip>
          ),
        },
        {
          name: "Branch",
          selector: (i) => (
            <Tooltip title={i?.branchId && branchList?.length > 0  ? branchList.find(elem => elem.branchId == i?.branchId)?.city : ""}>
              {i?.branchId && branchList?.length > 0  ? branchList.find(elem => elem.branchId == i?.branchId)?.branchName : ""}
            </Tooltip>
          ),
        },
        // {
        //   name: "Remarks",
        //   selector: (i) => (i?.remarks ? i?.remarks : "NA"),
        // },
        // {
        //   name: "Total Expense",
        //   selector: (i) =>   0,
        // },
        {
          name: "Status",
          cell: (i) => (
            <div className="d-flex">
              <button
                type="button"
                className={
                  i.isActive == 1 ? "btn btn-primary" : "btn btn-success"
                }
                style={{
                  width: "110px",
                  backgroundColor:
                    i.isActive == 2
                      ? i?.expectedEndTime && new Date() > new Date(i.expectedEndTime)
                        ? "red"
                        : "#4d5073"
                      : i.isActive == 1
                      ? "#0d6efd" : i.isActive == 3 ? "green"
                      : "#4d5073",
                }}
                onClick={() => {
                  // i.isActive == 1
                  //   ? navigate(`/endTrip/${i.tripId}`, {
                  //       state: { tripData: i },
                  //     })
                  //   : null
                  setItem(i);
                  onSelect(i);
                  console.log("sadfgasdsadadsad");
                }}
              >
                {i?.Freights?.length != 0 && i?.Freights?.filter((elem, i) => elem?.status == 12)?.length == i?.Freights?.length && i?.isActive != 3 ? "Delivered":  
                i?.Freights?.find((elem, i) => elem?.status == 11) ? "Unloading" : i?.isActive == 2
                  ? "Running"
                  : i.isActive == 1
                  ? "Start Trip"
                  : "Completed"}
              </button>
              {/* {i.isActive == 2 ? (
                i?.expectedEndTime && new Date() > new Date(i.expectedEndTime) ? (
                  <div
                    style={{
                      alignItems: "center",
                      marginLeft: "12px",
                      alignContent: "center",
                      padding: "7px 0 0 0",
                    }}
                  >
                    Delayed
                  </div>
                ) : null
              ) : null} */}
            </div>
          ),
        },
      ];
    });
  }
  useEffect(() => {
    if (display1 || display2) {
      dispatch(
        findTripAddress({
          offset: 0,
          // minKyc: "",
          // sortAs: "",
          // sortBy: "",
        })
      );
    }
  }, [display1, display2]);
  useEffect(() => {
    setIsTrips(
      authUser?.company?.isTrips && authUser?.user?.type == 2
        ? 3
        : authUser?.company?.isTrips && managerControlList?.tripAccess
        ? managerControlList?.tripAccess
        : 0
    );
  }, [authUser, managerControlList]);

  useEffect(() => {
      dispatch(
        getVehicleListAction({
          offset: "",
          search: search,
          minKyc: "",
          sortAs: "",
          sortBy: "",
          limit: 10,
        })
      );
  }, [search]);

  useEffect(() => {
    if (openDriver) {
      dispatch(
        getDriverList({
          offset: "",
          search: searchDriver,
          minKyc: "",
          sortAs: "",
          sortBy: "",
          limit: 10,
        })
      );
    }
  }, [searchDriver, openDriver]);

  useEffect(() => {
    removeItemFromAsyncStorage("row");
    console.log("bhai fsssslee", currentRow, "newOffset",newOffset);
    let payload = {};
    if (pending) {
      payload["isActive"] = "1";
    }
    if (completed) {
      payload["isActive"] = "3";
    }
    if (running) {
      payload["isActive"] = "2";
    }
    if (delayed) {
      payload["isActive"] = "9";
    }
    dispatch(
      getTripsNew({
        ...payload,
        offset: newOffset,
        limit: 10,
        fleetId: fleetIdTemp,
        driverId: driverIdTemp,
        startDateFrom: startDateFrom,
        startDateTo: startDateTo,
        endDateFrom: endDateFrom,
        endDateTo: endDateTo,
        source: sourceAddress,
        destination: destinationAddress,
        tripNo: tripNoTemp,
        branchId: branchId,
      })
    );
    console.log("pqwerewrpienndnfnsdfdsdf", startDateFrom, startDateTo, branchId);
  }, [
    fleetIdTemp,
    driverIdTemp,
    startDateFrom,
    startDateTo,
    endDateFrom,
    endDateTo,
    sourceAddress,
    destinationAddress,
    tripNoTemp,
    refresh,
    branchId
  ]);

  return (
    <div
      className="container topMargin sideBarMargin"
      style={{
        // paddingTop:"5.5rem",
        marginLeft: sideBar ? "220px" : "100px",
        maxWidth: sideBar ? windowWidth - 240 : windowWidth - 130,
      }}
    >
      <div
        className="main1"
        style={{ height: "1200px", backgroundColor: "white" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h1
              className="headingLow semiBold"
              style={{ marginBottom: "25px" }}
            >
              Trips
            </h1>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ paddingTop: "3px" }}>
              <Switch
                checked={tripAnalysis}
                onChange={toggleTripAnalysis}
                onColor="#EBF2F2"
                onHandleColor="#2E7C7B"
                handleDiameter={10}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                height={10}
                width={25}
                id="material-switch"
              />
            </div>
            <h1 className="headingLow semiBold" style={{ marginLeft: "15px" }}>
              Analysis
            </h1>
          </div>
        </div>
        <div>
          <Formik
            enableReinitialize
            initialValues={{
              vrn: vrn || "",
              company: "",
              status: "",
              driver: driverName || "",
              startDateFrom: startDateFrom ? moment(startDateFrom, "MM/DD/YYYY") : null,
              startDateTo: startDateTo ? moment(startDateTo, "MM/DD/YYYY") : null,
              endDateFrom: endDateFrom ? moment(endDateFrom, "MM/DD/YYYY") : null,
              endDateTo: endDateTo ? moment(endDateTo, "MM/DD/YYYY") : null,
              from: "",
              to: "",
              source: addressSource || "",
              destination: addressDest || "",
              tripNo: tripNoTemp || "",
              financialYear: "",
              financialYearFrom: "",
              financialYearTo: "",
              branchName : branchName || ""
            }}
            onSubmit={(values, actions) => {
              console.log("sdsadsad", values);
              actions.resetForm();
            }}
          >
            {({
              handleBlur,
              handleChange,
              handleSubmit,
              values,
              touched,
              isValid,
              errors,
              setFieldValue,
              resetForm,
            }) => (
              <Form onSubmit={handleSubmit}>
                <FormGroup
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    // gap: "50px",
                  }}
                >
                  <FormGroup>
                    <label for="vrn" className="heading3 semiBold">
                      Vehicle No:
                    </label>
                    <div
                      // onClick={() => {
                      //   setOpen(true);
                      // }}
                      className="custNamepadd3"
                    >
                      <input
                        className={`inputBoxCust1 ${
                          touched.amount && errors.amount ? "is-invalid" : ""
                        }`}
                        type="text"
                        id="vrn"
                        name="vrn"
                        touched={touched.vrn}
                        errors={errors.vrn}
                        // onBlur={handleBlur("vrn")}
                        onChange={(event) => {
                          setOpen(true);
                          setSearch(event.target.value);
                          setFieldValue("vrn", event.target.value, true);
                          if (!event.target.value) {
                            setFleetIdTemp("");
                          }
                        }}
                        value={values.vrn}
                        onClick={() => {
                          setOpen(!open)
                        }}
                        // autoFocus
                        placeholder="Select Vehicle"
                        autocomplete="off"
                        // onFocus={() => {
                        //   setOpen(true);
                        // }}
                        // onBlur={() => {
                        //   setOpen(false);
                        // }}
                        // placeholder="Enter Vechicle No"
                      />
                    </div>
                    <div style={{ position: "relative" }}>
                      {open ? (
                        <div
                          className="driverSearchContainer containerShadow"
                          style={{
                            width: "100%",
                            marginTop: "5px",
                            borderRadius: "8px",
                            border: "1px solid #E2E2E2",
                          }}
                        >
                          <div
                          style={{
                            position: "absolute",
                            top: "0.3rem",
                            right: "0.5rem",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            console.log("CloseButtonLogoCloseButtonLogoFleet");
                            setOpen(false);
                            setFleetIdTemp("")
                            setFieldValue("vrn", "", true );
                            setSearchParams({...params, fleetId: "", vrn : "", offset: 0})
                            setNewOffset(0)
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div>
                          {allFleets?.map((item, i) => {
                            return (
                              <>
                                {/* {item?.Fastag !== null ? ( */}
                                <div
                                  key={i}
                                  className="flexStyling padding8 "
                                  onClick={(event) => {
                                    setOpen(false);
                                    // setUserId(event.target.value);
                                    setFieldValue("vrn", item?.regNumber, true);
                                    setFleetIdTemp(item?.fleetId);
                                    setSearchParams({...params, fleetId: item?.fleetId, vrn : item?.regNumber, offset: 0})
                                    setNewOffset(0)
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  <input
                                    type="radio"
                                    name="vrn"
                                    value={item?.fleetId}
                                    id={item?.fleetId}
                                  />
                                  <div
                                    className="padding16L"
                                    value={item?.fleetId}
                                  >
                                    {item?.regNumber}
                                  </div>
                                </div>
                                {/* ) : (
                                    <></>
                                  )} */}
                              </>
                            );
                          })}
                          {vehCount == 0 ? (
                            <div className="heading3 semiBold padding16 padding24B">
                              No Vehicle Available
                            </div>
                          ) : fastVeh == undefined ? (
                            <div className="heading3 semiBold padding16 padding24B">
                              No Vehicle Available
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <label for="vrn" className="heading3 semiBold">
                      Trip Number
                    </label>
                    <div className="custNamepadd3">
                      <input
                        type="text"
                        id="vrn"
                        className={`inputBoxCust1 ${
                          touched.tripNo && errors.tripNo ? "is-invalid" : ""
                        }`}
                        name="vrn"
                        // onChange={handleChange("tripNo")}
                        value={values.tripNo}
                        onChange={(event) => {
                          setTripNoTemp(event.target.value);
                          setFieldValue("tripNo", event.target.value, true);
                          setNewOffset(0)
                          setSearchParams({...params, tripNo: event.target.value,  offset: 0});
                        }}
                        // onBlur={() => {
                        //   dispatch(
                        //     sendAnalitics("Enter_Amt_Web", {
                        //       upi_netBank_tripNo: values.tripNo,
                        //     })
                        //   );
                        //   handleBlur("tripNo");
                        // }}
                        touched={touched.tripNo}
                        errors={errors.tripNo}
                        placeholder="Enter TripNo"
                        autocomplete="off"
                      />
                    </div>
                  </FormGroup>
                  {/* <FormGroup>
                  <label for="vrn" className="heading3 semiBold">
                    Status
                  </label>
                  <input
                    type="text"
                    id="vrn"
                    className={`form-control-1 ${
                      touched.amount && errors.amount ? "is-invalid" : ""
                    }`}
                    name="vrn"
                    // onChange={handleChange("amount")}
                    value={values.status}
                    // onBlur={() => {
                    //   dispatch(
                    //     sendAnalitics("Enter_Amt_Web", {
                    //       upi_netBank_amount: values.amount,
                    //     })
                    //   );
                    //   handleBlur("amount");
                    // }}
                    touched={touched.amount}
                    errors={errors.amount}
                    placeholder="Select Status"
                  />
                </FormGroup> */}
                  <FormGroup>
                    <label for="driver" className="heading3 semiBold">
                      Driver
                    </label>
                    <div
                      // onClick={() => {
                      //   setOpenDriver(true);
                      // }}
                      className="custNamepadd3"
                    >
                      <input
                        className={`inputBoxCust1 ${
                          touched.amount && errors.amount ? "is-invalid" : ""
                        }`}
                        type="text"
                        id="driver"
                        name="driver"
                        touched={touched.driver}
                        errors={errors.driver}
                        // onBlur={handleBlur("driver")}
                        onChange={(event) => {
                          setOpenDriver(true);
                          setSearchDriver(event.target.value);
                          setFieldValue("driver", event.target.value, true);
                          if (!event.target.value) {
                            setDriverIdTemp("");
                          }
                        }}
                        value={values.driver}
                        onClick={() => {
                          setOpenDriver(!openDriver)
                        }}
                        // autoFocus
                        placeholder="Select Driver"
                        autocomplete="off"
                        // onFocus={() => {
                        //   setOpenDriver(true);
                        // }}
                        // onBlur={() => {
                        //   setOpenDriver(false);
                        // }}
                      />
                    </div>

                    <div style={{ position: "relative" }}>
                      {openDriver ? (
                        <div
                          className="driverSearchContainer containerShadow"
                          style={{
                            width: "100%",
                            marginTop: "5px",
                            borderRadius: "8px",
                            border: "1px solid #E2E2E2",
                          }}
                        >
                          <div
                          style={{
                            position: "absolute",
                            top: "0.3rem",
                            right: "0.3rem",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setOpenDriver(false);
                            setDriverIdTemp("");
                            setFieldValue("driver", "", true );
                            setSearchParams({...params, driverId: "", driverName: "", offset: 0})
                            setNewOffset(0)
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div>
                          {driverList?.map((item, i) => {
                            return (
                              <>
                                {item?.Fastag !== null ? (
                                  <div
                                    key={i}
                                    className="flexStyling padding8 "
                                    onClick={(event) => {
                                      setOpenDriver(false);
                                      // setUserId(event.target.value);
                                      setFieldValue(
                                        "driver",
                                        item?.User?.fullName,
                                        true
                                      );
                                      setDriverIdTemp(item?.User?.userId);
                                      setSearchParams({...params, driverId: item?.User?.userId, driverName: item?.User?.fullName, offset: 0})
                                      setNewOffset(0)
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    <input
                                      type="radio"
                                      name="driver"
                                      value={item?.User?.userId}
                                      id={item?.User?.userId}
                                    />
                                    <div className="padding16L">
                                      {item?.User?.fullName.length > 35
                                        ? item?.User?.fullName.split(0, 35) +
                                          "..."
                                        : item?.User?.fullName}
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </>
                            );
                          })}
                          {driverCount == 0 ? (
                            <div className="heading3 semiBold padding16 padding24B">
                              No driver Available
                            </div>
                          ) : driverCount == undefined ? (
                            <div className="heading3 semiBold padding16 padding24B">
                              No driver Available
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                      <div style={{ margin: "0px 0 0px 96px", color: "red" }}>
                        {errors.userId && touched.userId ? (
                          <div>*{errors.userId}</div>
                        ) : null}
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <label for="financialYear" className="heading3 semiBold">
                      Select Financial Year
                    </label>
                    <div className="custNamepadd3">
                      <input
                        type="text"
                        name="financialYear"
                        id="financialYear"
                        placeholder={"Select Financial Year"}
                        className={`inputBoxCust1 ${
                          touched.financialYear && errors.financialYear
                            ? "is-invalid"
                            : ""
                        }`}
                        aria-label="Default select example"
                        onChange={(e) => {
                          setDisplay3(true);
                          if (!e.target.value) {
                            setFieldValue("financialYear", "", true);
                            setFieldValue("financialYearFrom", "", true);
                            setFieldValue("financialYearTo", "", true);
                          } else {
                            setFieldValue(
                              "financialYear",
                              e.target.value,
                              true
                            );
                          }
                        }}
                        onClick={() => {
                          setDisplay3(!display3);
                        }}
                        value={values.financialYear}
                        // onBlur={handleBlur("financialYear")}
                        errors={errors.financialYear}
                      ></input>
                    </div>
                    {display3 ? (
                      <div
                        className="padding16 newCashback whiteBackground"
                        style={{
                          position: "absolute",
                          width: "200px",
                          height: "275px",
                          zIndex: "90",
                          marginTop: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            setDisplay3(false);
                            //dispatch(clearAllDriversByVrn());
                            setFieldValue("financialYearFrom", "", true);
                            setFieldValue("financialYearTo", "", true);
                            setFieldValue("financialYear", "", true);
                          }}
                          style={{
                            position: "absolute",
                            right: "0.5rem",
                            top: "0.5rem",
                            cursor: "pointer",
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div>
                        <div
                          style={{
                            overflowY: "scroll",
                            overflowX: "hidden",
                            height: "240px",
                          }}
                        >
                          {financialYearList?.map((data, i) => {
                            let title = data?.title;
                            return (
                              <div
                                key={i}
                                className="padding8 row"
                                onClick={() => {
                                  setFieldValue(
                                    "financialYear",
                                    data?.title,
                                    true
                                  );
                                  setFieldValue(
                                    "financialYearFrom",
                                    data?.from,
                                    true
                                  );
                                  setFieldValue(
                                    "financialYearTo",
                                    data?.to,
                                    true
                                  );
                                  setStartDateFrom(moment(data?.from).format("MM/DD/YYYY"));
                                  setStartDateTo(moment(data?.to).format("MM/DD/YYYY"));
                                  setSearchParams({...params, startDateFrom: moment(data?.from).format("MM/DD/YYYY"), startDateTo: moment(data?.to).format("MM/DD/YYYY"), offset: 0});
                                  setNewOffset(0)
                                  setDisplay3(false);
                                }}
                              >
                                {color2 === i ? (
                                  <div className="col-1">
                                    <SvgImage name="SelectedRadio" />
                                  </div>
                                ) : (
                                  <div className="col-1">
                                    <SvgImage name="UnselectedRadio" />
                                  </div>
                                )}
                                <div
                                  className="col-9"
                                  style={{ textAlign: "left" }}
                                >
                                  {title}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </FormGroup>
                  <button
                    className="greenButton"
                    style={{ width: "160px" }}
                    type="button"
                    onClick={() => {
                      setTripNoTemp("");
                      setDriverIdTemp("");
                      setSearchDriver("");
                      setFleetIdTemp("");
                      setStartDateFrom("");
                      setStartDateTo("");
                      setEndDateFrom("");
                      setEndDateTo("");
                      setSearchDestination("");
                      setSearchSource("");
                      setDestinationAddress("");
                      setSourceAddress("");
                      setBranchId("");
                      resetForm();
                    }}
                  >
                    Clear All Filter
                  </button>
                  <button
                    className="greenButton"
                    style={{ width: "160px" }}
                    type="button"
                    onClick={() => {
                      const data = {
                        tripNo: tripNoTemp,
                        driverUserId: driverIdTemp,
                        fleetId: fleetIdTemp,
                        startDateFrom:
                          moment(startDateFrom).format("MM/DD/YYYY"),
                        startDateTo: moment(startDateTo).format("MM/DD/YYYY"),
                        endDateFrom: moment(endDateFrom).format("MM/DD/YYYY"),
                        endDateTo: moment(endDateTo).format("MM/DD/YYYY"),
                        branchId: branchId,
                      };
                      dispatch(
                        downloadTripDataExcel(data, (res) => {
                          console.log(
                            "downloadTripDataExceldownloadTripDataExcel",
                            res?.data,
                            res?.data?.data?.url
                          );
                          if (res.status == 200)
                            window.open(res?.data?.data?.url);
                        })
                      );
                    }}
                  >
                    Export Trips
                  </button>
                </FormGroup>

                <FormGroup
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    // gap: "50px",
                  }}
                >
                  <FormGroup>
                    <label for="startDate" className="heading3 semiBold">
                      Start Date
                    </label>
                    <div
                      className="custNamepadd3 row"
                      style={{ width: "192px" }}
                    >
                      <div className="col-9">
                        <DateRangePickerField
                          classname="inputBoxDateRange1"
                          name="startDate"
                          header="Select Start date"
                          value={{startDate : values?.startDateFrom, endDate: values?.startDateTo}}
                          onChange={(v) => {
                            setFieldValue("startDateFrom", v[0], true);
                            setStartDateFrom(v[0] ? moment(v[0]).format("MM/DD/YYYY") : "");
                            setSearchParams({...params, startDateFrom: v[0] ? moment(v[0]).format("MM/DD/YYYY"): "",startDateTo: v[1] ? moment(v[1]).format("MM/DD/YYYY"): "",  offset: 0});
                            setFieldValue("startDateTo", v[1], true);
                            setNewOffset(0)
                            setStartDateTo(v[1] ? moment(v[1]).format("MM/DD/YYYY") : "");
                          }}
                          //onChange={(v) => setFieldValue("endDate", v, true)}
                          maxDate={
                            values.endDateTo === "" ? "" : values.endDateTo
                          }
                          // maxDate={new Date()}
                          ref1={datepickerRefEnd}
                          style={{ width: "100px" }}
                          isClearable={startDateFrom ? true : false}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="date-input"
                          for="startDate"
                          style={{
                            position: "relative",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickDatepickerIcon2();
                          }}
                        >
                          {!startDateTo ? (
                            <SvgImage
                              name="CalenderLogo"
                              width="32"
                              height="32"
                              // classname="date-logo"
                            />
                          ) : (
                            <></>
                          )}
                        </label>
                      </div>
                    </div>
                    <div
                      className="heading4 Regular"
                      style={{ margin: "7px 0 0px 0", color: "red" }}
                    >
                      {errors.endDateFrom && touched.endDateFrom ? (
                        <div>*{errors.endDateFrom}</div>
                      ) : null}
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <label for="endtDate" className="heading3 semiBold">
                      End Date
                    </label>
                    <div
                      className="custNamepadd3 row"
                      style={{ width: "192px" }}
                    >
                      <div className="col-9">
                        <DateRangePickerField
                          classname="inputBoxDateRange1"
                          name="endtDate"
                          header="Select End date"
                          value={{startDate :values.endDateFrom, endDate: values.endDateTo}}
                          onChange={(v) => {
                            setFieldValue("endDateFrom", v[0], true);
                            setEndDateFrom(v[0] ? moment(v[0]).format("MM/DD/YYYY") : "");
                            setSearchParams({...params, endDateFrom: v[0] ? moment(v[0]).format("MM/DD/YYYY"): "",endDateTo: v[1] ? moment(v[1]).format("MM/DD/YYYY"): "", offset: 0});
                            setFieldValue("endDateTo", v[1], true);
                            setNewOffset(0)
                            setEndDateTo(v[1] ? moment(v[1]).format("MM/DD/YYYY") : "");
                          }}
                          //onChange={(v) => setFieldValue("endDate", v, true)}
                          minDate={
                            values.startDateFrom === ""
                              ? ""
                              : values.startDateFrom
                          }
                          // maxDate={new Date()}
                          ref1={datepickerRefStart}
                          style={{ width: "100px" }}
                          isClearable={endDateFrom ? true : false}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="date-input"
                          for="endDate"
                          style={{
                            position: "relative",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickDatepickerIcon1();
                          }}
                        >
                          {!endDateTo ? (
                            <SvgImage
                              name="CalenderLogo"
                              width="32"
                              height="32"
                              // classname="date-logo"
                            />
                          ) : (
                            <></>
                          )}
                        </label>
                      </div>
                    </div>
                    <div
                      className="heading4 Regular"
                      style={{ margin: "7px 0 0px 0", color: "red" }}
                    >
                      {errors.endDateFrom && touched.endDateFrom ? (
                        <div>*{errors.endDateFrom}</div>
                      ) : null}
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <label for="source" className="heading3 semiBold">
                      From
                    </label>
                    <div className="custNamepadd3">
                      <input
                        type="text"
                        name="source"
                        id="source"
                        placeholder={"Source City"}
                        className={`inputBoxCust1 ${
                          touched.amount && errors.amount ? "is-invalid" : ""
                        }`}
                        aria-label="Default select example"
                        onChange={(e) => {
                          setDisplay1(true);
                          console.log("e.target.value", e.target.value);
                          setSearchSource(e.target.value);
                          setFieldValue("source", e.target.value, true);
                        }}
                        onClick={() => {
                          setDisplay1(!display1);
                        }}
                        value={values.source}
                        onBlur={handleBlur("source")}
                        errors={errors.source}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            findSearch1();
                          }
                        }}
                      ></input>
                    </div>
                    {display1 ? (
                      <div
                        className="padding16 newCashback whiteBackground"
                        style={{
                          position: "absolute",
                          width: "350px",
                          height: "275px",
                          zIndex: "90",
                        }}
                      >
                        <div
                          onClick={() => {
                            setDisplay1(false);
                            setSearchSource("");
                            setSourceAddress("");
                            setFieldValue("source", "", true);
                            setSearchParams({...params, sourceAddress: "", addressSource:  "", offset: 0});
                            setNewOffset(0)

                          }}
                          style={{
                            position: "absolute",
                            right: "0.5rem",
                            top: "0.5rem",
                            cursor: "pointer",
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div>
                        <div
                          style={{
                            overflowY: "scroll",
                            overflowX: "hidden",
                            height: "240px",
                          }}
                        >
                          {searchSource != "" ? (
                            tripAddress?.rows?.map((data, i) => {
                              let city = data?.cityName;
                              let state = data?.State?.stateName;
                              return (
                                <div
                                  key={i}
                                  className="padding8 row"
                                  onClick={() => {
                                    setColor1(i);
                                    setDisplay1(false);
                                    console.log("asdadsa", data?.cityName);
                                    //setUserId(data?.User?.userId);
                                    setSourceAddress(data?.addressId);
                                    setFieldValue(
                                      "source",
                                      data?.cityName +
                                        "-" +
                                        data?.State?.stateName,
                                      true
                                    );
                                    setSearchParams({...params, sourceAddress: data?.addressId, addressSource:  data?.cityName + "-" + data?.State?.stateName, offset: 0});
                                    setNewOffset(0)
                                  }}
                                >
                                  {color1 === i ? (
                                    <div className="col-1">
                                      <SvgImage name="SelectedRadio" />
                                    </div>
                                  ) : (
                                    <div className="col-1">
                                      <SvgImage name="UnselectedRadio" />
                                    </div>
                                  )}
                                  {/* <div className="col-1">
                          <SvgImage name="UnselectedRadio" />
                        </div> */}
                                  <div
                                    className="col-11"
                                    style={{ textAlign: "left" }}
                                  >
                                    {city} - {state}
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <>
                              {tripAddress?.rows?.map((data, i) => {
                                let city = data?.cityName;
                                let state = data?.stateName;

                                console.log("check status", city, state);
                                // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                                return (
                                  <div
                                    key={i}
                                    className="padding8 row"
                                    onClick={() => {
                                      setColor1(i);
                                      setDisplay1(false);
                                      //setUserId(data?.User?.userId);
                                      setSourceAddress(data?.addressId);
                                      setSearchParams({...params, sourceAddress: data?.addressId, addressSource:  data?.cityName + "-" + data?.State?.stateName, offset: 0});
                                      setNewOffset(0)
                                      setFieldValue(
                                        "source",
                                        data?.cityName + "-" + data?.stateName,
                                        true
                                      );
                                    }}
                                  >
                                    {color1 === i ? (
                                      <div className="col-1">
                                        <SvgImage name="SelectedRadio" />
                                      </div>
                                    ) : (
                                      <div className="col-1">
                                        <SvgImage name="UnselectedRadio" />
                                      </div>
                                    )}
                                    <div
                                      className="col-11"
                                      style={{ textAlign: "left" }}
                                    >
                                      {city} - {state}
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <label for="destination" className="heading3 semiBold">
                      To
                    </label>
                    <div className="custNamepadd3">
                      <input
                        type="text"
                        name="destination"
                        id="destination"
                        placeholder={"Destination City"}
                        className={`inputBoxCust1 ${
                          touched.amount && errors.amount ? "is-invalid" : ""
                        }`}
                        aria-label="Default select example"
                        onChange={(e) => {
                          setDisplay2(true);
                          console.log("e.target.value", e.target.value);
                          // setSearchDestination(e.target.value);
                          setFieldValue("destination", e.target.value, true);
                        }}
                        onClick={() => {
                          setDisplay2(!display2);
                        }}
                        value={values.destination}
                        onBlur={handleBlur("destination")}
                        errors={errors.destination}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            findSearch2();
                          }
                        }}
                      ></input>
                    </div>
                    {display2 ? (
                      <div
                        className="padding16 newCashback whiteBackground"
                        style={{
                          position: "absolute",
                          width: "350px",
                          height: "275px",
                          zIndex: "90",
                        }}
                      >
                        <div
                          onClick={() => {
                            setDisplay2(false);
                            setSearchDestination("");
                            setDestinationAddress("");
                            setFieldValue("destination", "", true);
                            setSearchParams({...params, destinationAddress: "", addressDest:  "", offset: 0});
                            setNewOffset(0)
                          }}
                          style={{
                            position: "absolute",
                            right: "0.5rem",
                            top: "0.5rem",
                            cursor: "pointer",
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div>
                        <div
                          style={{
                            overflowY: "scroll",
                            overflowX: "hidden",
                            height: "240px",
                          }}
                        >
                          {searchDestination != "" ? (
                            tripAddress?.rows?.map((data, i) => {
                              let city = data?.cityName;
                              let state = data?.stateName;
                              return (
                                <div
                                  key={i}
                                  className="padding8 row"
                                  onClick={() => {
                                    setColor2(i);
                                    setDisplay2(false);
                                    //setUserId(data?.User?.userId);
                                    setDestinationAddress(data?.addressId);
                                    setSearchParams({...params, destinationAddress: data?.addressId, addressDest: data?.cityName + "-" + data?.stateName, offset: 0});
                                    setNewOffset(0)
                                    setFieldValue(
                                      "destination",
                                      data?.cityName + "-" + data?.stateName,
                                      true
                                    );
                                  }}
                                >
                                  {color2 === i ? (
                                    <div className="col-1">
                                      <SvgImage name="SelectedRadio" />
                                    </div>
                                  ) : (
                                    <div className="col-1">
                                      <SvgImage name="UnselectedRadio" />
                                    </div>
                                  )}
                                  {/* <div className="col-1">
                          <SvgImage name="UnselectedRadio" />
                        </div> */}
                                  <div
                                    className="col-11"
                                    style={{ textAlign: "left" }}
                                  >
                                    {city} - {state}
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <>
                              {tripAddress?.rows?.map((data, i) => {
                                let city = data?.cityName;
                                let state = data?.stateName;

                                console.log("check status", city, state);
                                // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                                return (
                                  <div
                                    key={i}
                                    className="padding8 row"
                                    onClick={() => {
                                      setColor2(i);
                                      setDisplay2(false);
                                      //setUserId(data?.User?.userId);
                                      setDestinationAddress(data?.addressId);
                                      setSearchParams({...params, destinationAddress: data?.addressId, addressDest: data?.cityName + "-" + data?.stateName, offset: 0});
                                      setNewOffset(0)
                                      setFieldValue(
                                        "destination",
                                        data?.cityName + "-" + data?.stateName,
                                        true
                                      );
                                    }}
                                  >
                                    {color2 === i ? (
                                      <div className="col-1">
                                        <SvgImage name="SelectedRadio" />
                                      </div>
                                    ) : (
                                      <div className="col-1">
                                        <SvgImage name="UnselectedRadio" />
                                      </div>
                                    )}
                                    <div
                                      className="col-11"
                                      style={{ textAlign: "left" }}
                                    >
                                      {city} - {state}
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </FormGroup>
                  <FormGroup>
                        <label for="vrn" className="heading3 semiBold">
                          Branch:
                        </label>
                        <div
                          className="custNamepadd3"
                        >
                          <input
                            className={`inputBoxCust1 form-control-1 ${
                              touched.branch && errors.branch
                                ? "is-invalid"
                                : ""
                            }`}
                            type="text"
                            id="branch"
                            name="branch"
                            touched={touched.branch}
                            errors={errors.branch}
                            // onBlur={() => {
                            //   handleBlur("branch");
                            //   setOpen2(false);
                            // }}
                            onClick={() => {
                              setOpen2(!open2);
                            }}
                            autoComplete="off"
                            onChange={(event) => {
                              console.log("kkjjsss", event.target.value);
                              setOpen2(true);
                              setSearchBranch(event.target.value);
                              setFieldValue("branchName", event.target.value, true);
                            }}
                            value={values.branchName}
                            // onFocus={(e) => {
                            //   setOpen2(true);
                            // }}
                            placeholder="Select Branch"
                            disabled={
                              values?.isDummy == 2 || values?.isDummy == "0"
                                ? true
                                : false
                            }
                          />
                          {console.log(
                            "values.branch.branch",
                            values?.branchId
                          )}
                        </div>
                        <div style={{ position: "relative" }}>
                          {open2 ? (
                            <div className="driverSearchContainer containerShadow">
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0.3rem",
                                  right: "0.3rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  console.log("herecomming....");
                                  setBranchId("")
                                  setOpen2(false);
                                  setFieldValue("branchName", "", true );
                                  setSearchParams({...params, branchId: "", branchName: "", offset: 0});
                                  setNewOffset(0)
                                }}
                              >
                                <SvgImage name="CloseButtonLogo" />
                              </div>
                              {console.log("branchList",branchList)}
                              { branchList?.length != 0  ? branchList?.map((item, i) => {
                                return (
                                  <>
                                  {console.log("itemitem",item)}
                                    {item?.Fastag !== null ? (
                                      <div
                                        key={i}
                                        className="flexStyling padding8 "
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={(event) => {
                                          setBranchId(item?.branchId)
                                          setSearchParams({...params, branchId: item?.branchId, branchName: item?.branchName, offset: 0});
                                          setNewOffset(0)
                                          setFieldValue(
                                            "branchName",
                                            item?.branchName,
                                            true
                                          );
                                          setFieldValue(
                                            "branchId",
                                            item?.branchId,
                                            true
                                          );
                                          setOpen2(false);
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="driver"
                                          value={item?.branchId}
                                          id={item?.branchId}
                                        />
                                        <div className="padding16L">
                                          {item?.branchName}
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                );
                              }):
                              (
                                <div className="heading3 semiBold padding16 padding24B">
                                  No Branch Available
                                </div>
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                  </FormGroup>
                </FormGroup>
              </Form>
            )}
          </Formik>
          <div className="listAction">
            <div className="txnCategory">
              <button
                onClick={() => filterList("all")}
                className={
                  all
                    ? "greenButtonNew heading4 Medium"
                    : "greenButtonNewNotSelected heading4 Medium"
                }
              >
                <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                    All
                  </div>
                  <div className={` ${all ? "countAll" : "countAllInactive"}`}>
                    {countAll}
                  </div>
                </div>
              </button>
              <button
                onClick={() => filterList("pending")}
                className={
                  pending
                    ? "greenButtonNew heading4 Medium"
                    : " greenButtonNewNotSelected heading4 Medium"
                }
              >
                <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                    Not Started
                  </div>
                  <div
                    className={` ${pending ? "countAll" : "countAllInactive"}`}
                  >
                    {countNotStarted}
                  </div>
                </div>
              </button>
              <button
                onClick={() => filterList("completed")}
                className={
                  completed
                    ? "greenButtonNew heading4 Medium"
                    : "greenButtonNewNotSelected heading4 Medium"
                }
              >
                <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                    Completed
                  </div>
                  <div
                    className={` ${
                      completed ? "countAll" : "countAllInactive"
                    }`}
                  >
                    {countComplete}
                  </div>
                </div>
              </button>
              <button
                onClick={() => filterList("running")}
                className={
                  running
                    ? "greenButtonNew heading4 Medium"
                    : "greenButtonNewNotSelected heading4 Medium"
                }
              >
                <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                    Running
                  </div>
                  <div
                    className={`${running ? "countAll" : "countAllInactive"}`}
                  >
                    {countRunning}
                  </div>
                </div>
              </button>
              <button
                onClick={() => filterList("delayed")}
                className={
                  delayed
                    ? "greenButtonNew heading4 Medium"
                    : "greenButtonNewNotSelected heading4 Medium"
                }
              >
                <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                    Delayed
                  </div>
                  <div
                    className={`${delayed ? "countAll" : "countAllInactive"}`}
                  >
                    {countDelayed}
                  </div>
                </div>
              </button>
            </div>
            <div className="rightAction">
              {/* <div class="dropdown" style={{ marginRight: "20px" }}>
              <button
                type="button"
                class="btnCatSelected btn-secondary dropdown-toggle"
                data-toggle="dropdown"
                style={{ width: "90px" }}
                onClick={alert('Coming soon')}
                // disabled={true}
              >
                {" "}
                Action
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#">
                    action
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    response
                  </a>
                </li>
              </ul>
            </div> */}
              <div>
                <button
                  type="button"
                  className="greenButtonNew btn-secondary"
                  // style={{ width: "160px" }}
                  onClick={() => {
                    console.log("bulkSalarybulkSalary11", bulkSalary);
                    setBulkSalary(!bulkSalary);
                  }}
                >
                  + Add Bulk Trips
                </button>
                <button
                  type="button"
                  className="greenButtonNew btn-secondary"
                  // style={{ width: "160px" }}
                  onClick={toggleOpenLrList}
                >
                  + Create New Trip
                </button>
              </div>
            </div>
          </div>
          {/* <Table style={{marginTop:'12px'}}>
                    <thead>
                      <tr className="table-header-customer-details">
                        <th>Trip No</th>
                        <th>Vehicle No</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Customer</th>
                        <th>Total Expense</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                        {tripsList && tripsList.map((entry, k)=>{
                            return(
                            <tr onClick={(ent)=>{onSelect(entry)}}>
                              <td>
                                  <div className="booking_title">
                                      <p className="FontNB">{entry.tripId}</p>
                                  </div>
                              </td>
                              <td>
                                  <div className="booking_title">
                                      <p className="FontNB">{entry.Fleet.regNumber}</p>
                                  </div>
                              </td>
                              <td>
                                  <div className="booking_title">
                                      <p className="FontNB">{entry.source}</p>
                                  </div>
                              </td>
                              <td>
                                  <div className="booking_title">
                                      <p className="FontNB">{entry.destination || "N/A"}</p>
                                  </div>
                              </td>
                              <td>
                                  <div className="booking_title">
                                      <p className="FontNB">{entry.customerName}</p>
                                  </div>
                              </td>
                              <td>
                                  <div className="booking_title">
                                      <p className="FontNB">₹{entry.cashExpanse}</p>
                                  </div>
                              </td>
                              <td>
                                  <div className="booking_title">
                                      <button type="button"  className="btnCatSelected" style={{background:"#09BD7B", width:'100px'}}>{entry.status || 'completed'}</button>
                                  </div>
                              </td>
                              </tr>)
                            
                          })                       
                      }
                      
                    </tbody>
                    </Table> */}
          {console.log(
            "tripsCossssunt",
            tripsCount == undefined,
            fetchingTrips,
            tripsCount > 0 && tripsListNew?.length == 0
          )}
          {tripsCount == undefined ||
          fetchingTrips ||
          (tripsCount > 0 && tripsListNew?.length == 0) ? (
            <div
              className="mt-2 boxContainer"
              style={{
                padding: 70,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BallTriangle
                height={70}
                width={70}
                radius={5}
                color="#ED752E"
                ariaLabel="ball-triangle-loading"
                wrapperClass={{}}
                wrapperStyle=""
                visible={true}
              />
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={tripsListNew}
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: "#ededf1",
                    fontSize: "16px",
                    fontWeight: "bold",
                  },
                },
                cells: {
                  style: { fontSize: "14px", minHeight: "50px" },
                },
              }}
              // fixedHeader
              // fixedHeaderScrollHeight='450px'
              // selectableRows
              selectableRowsHighlight
              highlightOnHover
              // onSelectedRowsChange={(row) => {
              //   console.log("njnjnfjnre", row);
              //   setCurrentRow(row?.selectedRows[0]);
              // }}
              // selectableRowSelected={(row) => {
              //   return row?.tripId == currentRow?.tripId;
              // }}
              // selectableRowsSingle={true}
              // pagination
              onRowClicked={(row) => {
                onSelect(row);
              }}
              expandableRows
              expandableRowExpanded={(row) => {
                console.log("knnirii", row?.tripId == currentRow?.tripId);
                return row?.tripId == currentRow?.tripId;
              }}
              // expandableIcon={<></>}
              // expandableRowsHideExpander={true}
              // expandOnRowClicked
              // onRowClicked={(row) => setCurrentRow(row)}
              expandableRowsComponent={LrList}
              onRowExpandToggled={(bool, row) => {
                console.log("knnirijjjjji");
                setCurrentRow(row);
              }}
            />
          )}

          {/* { */}
          <div className="reactPagination leftAlign">
            {console.log("reactPagination", selectedPage)}
            <ReactPaginate
              breakLabel="..."
              nextLabel=" >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              // initialPage={initialPage}
              forcePage={selectedPage}
              previousLabel="<"
              renderOnZeroPageCount={null}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
          {/* } */}
          {modal ? (
            <TripModalV2
              toggle={createTripV2}
              modal={modal}
              setModal={setModal}
              location={"/trips/"}
              toggleOpenLrList={closeOpenLrList}
              chooseRouteModalToggle={showRouteModalToggle}
              lr={"1"}
            />
          ) : null}

          {openEndTripModal ? (
            <EndTripModal
              toggle={toggleEndTripModal}
              modal={openEndTripModal}
              setModal={setOpenEndTripModal}
              location={"/trips/"}
              tripId={item?.tripId}
              tripData={item}
              refreshList={() => {
                setRefresh(!refresh);
              }}
              tripExpense={tripExpense}
              setTripExpense={setTripExpense}
            />
          ) : null}
          {chooseRouteModal ? (
            <ChooseRoute
              toggle={chooseRouteModalToggle}
              createTrip={createTripModalToggle}
              modal={chooseRouteModal}
              setPaymentDetailsModal={setPaymentDetailsModal}
              setModal={setChooseRouteModal}
              setRouteData={setRouteData}
              // location={"/lr/"}
            />
          ) : null}

          {openLrList ? (
            <AddLr
              toggle={toggleOpenLrList}
              freight={openLrList}
              location={"/trips/"}
              onSubmit={(lrList) => {
                console.log("kkkjjjjjjjjj", lrList);
                chooseRouteModalToggle();
                toggleOpenLrList();
                setSelectedLr(lrList);
              }}
              onSubmit2={(lrList) => {
                console.log("kkkjjjjjjjjj", lrList);
                // chooseRouteModalToggle();
                // toggleOpenLrList();
                setSelectedLr(lrList);
              }}
              onSkip={() => {
                setChooseRouteModal(true);
                toggleOpenLrList();
              }}
              trip={"1"}
              // setFreight={setFreight}
            />
          ) : null}
          {createTripModal ? (
            <CreateTripFromLR
              toggle={createTripModalToggle}
              modal={createTripModal}
              setModal={setCreateTripModal}
              location={"/trip/"}
              selectedRow={selectedLr}
              setSelectedRow={setSelectedLr}
              setPaymentDetailsModal={setPaymentDetailsModal}
              routeData={routeData}
              setTripData={setTripData}
              vehicleMilage={vehicleMilage}
              driverSalary={driverSalary}
              setVehicleMilage={setVehicleMilage}
              setDriverSalary={setDriverSalary}
              authUser={authUser}
              setRouteData={setRouteData}
              setTripExpense={setTripExpense}
            />
          ) : null}

          {paymentDetailsModal ? (
            <PaymentDetails
              toggle={paymentDetailsModalToggle}
              tripData={tripData}
              modal={paymentDetailsModal}
              setModal={setPaymentDetailsModal}
              routeData={routeData}
              setRouteData={setRouteData}
              setItemTemp={setTripData}
              vehicleMilage={vehicleMilage}
              driverSalary={driverSalary}
              tripExpense={tripExpense}
              // location={"/lr/"}
            />
          ) : null}
        </div>
      </div>

      {bulkSalary ? (
        <AddBulkTrip
          toggleModal={() => setBulkSalary(!bulkSalary)}
          isOpen={bulkSalary}
          handleClose={() => setBulkSalary(false)}
          // data={data}
        />
      ) : null}

      {/* {toastObject.toastStatus ? (
        <Toast
          success={toastObject?.status}
          message={toastObject?.message}
          toggleModal={() => {
            dispatch(
              toastStatus({
                toastStatus: false,
              })
            );
          }}
          isOpen={toastObject?.toastStatus}
          name="trips"
          handleClose={() => {
     
            window.location='/trips/';
            //alert("close button clicked");
          }}
        />
      ) : (
        <></>
      )} */}
      {toastObject.toastStatus ? (
        <Toast
          success={toastObject?.status}
          message={toastObject?.message}
          toggleModal={toastObject?.toggleModal}
          isOpen={toastObject?.toastStatus}
          name="trips"
          handleClose={toastObject?.handleClose}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default TripsMainV2;
